import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer } from 'mobx-react'

@observer(['organizations'])
export default class EditOrg extends Component {
  render() {

    const i = this.props.organizations.all.findIndex((org) => org.id == this.props.params.orgId)
    const org = this.props.organizations.all[i]

    return (
      <div className="content">
        { org.name }<br />
        { org.address }<br />
        { org.city }, { org.state } { org.zip }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/editorg.js